import { fetchClubsError, fetchClubsPending, fetchClubsSuccess } from './actions';
import { fetchClubs } from 'utils/api/clubs';

const exportFunc = () => {
  return (dispatch: any) => {
    dispatch(fetchClubsPending());
    fetchClubs()
      .then((res) => {
        return res.data;
      })
      .then((clubsRawData) => {
        const clubs = clubsRawData.map((clubsRawData: any) => ({
          id: clubsRawData.id.toString(),
          name: clubsRawData.name,
        }));

        dispatch(fetchClubsSuccess(clubs));
        return clubs;
      })
      .catch((error) => {
        console.log(error);
        dispatch(fetchClubsError('Fetching clubs problem.'));
      });
  };
};

export default exportFunc;
